import * as THREE from 'three';

export class Ball {
  readonly mesh: THREE.Mesh;
  readonly radius: number;
  readonly velocity = new THREE.Vector3(0, 0, 0);
  launched = false;

  /** 0..1 flash amount; any contact (paddle / brick / wall) spikes this to 1
   *  and it decays each frame so the ball briefly glows on hit. */
  private hitFlashAmount = 0;
  private readonly baseEmissiveIntensity = 1.4;

  constructor(radius = 0.32) {
    this.radius = radius;
    const geometry = new THREE.SphereGeometry(radius, 24, 16);
    const material = new THREE.MeshStandardMaterial({
      color: '#ffffff',
      roughness: 0.28,
      metalness: 0.35,
      emissive: '#dbe4ff',
      emissiveIntensity: this.baseEmissiveIntensity,
    });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.castShadow = true;
    this.mesh.position.set(0, radius, 7.6);
  }

  get position(): THREE.Vector3 {
    return this.mesh.position;
  }

  resetOnPaddle(paddleX: number, paddleZ: number, paddleHalfDepth: number): void {
    this.launched = false;
    this.velocity.set(0, 0, 0);
    this.mesh.position.set(paddleX, this.radius, paddleZ - paddleHalfDepth - this.radius - 0.02);
  }

  launch(dirX = 0.35, speed = 9.5): void {
    if (this.launched) return;
    this.launched = true;
    const dir = new THREE.Vector3(dirX, 0, -1).normalize();
    this.velocity.copy(dir.multiplyScalar(speed));
  }

  /** Boost the ball's emissive briefly — called on every contact (paddle,
   *  brick, wall) so hits read as a punch of light on the ball itself. */
  hitFlash(): void {
    this.hitFlashAmount = 1;
  }

  /** Called each frame from Game to decay the hit-flash back to baseline. */
  updateGlow(): void {
    const mat = this.mesh.material as THREE.MeshStandardMaterial;
    if (this.hitFlashAmount > 0.001) {
      mat.emissiveIntensity = this.baseEmissiveIntensity + this.hitFlashAmount * 3.5;
      this.hitFlashAmount *= 0.86;
    } else {
      mat.emissiveIntensity = this.baseEmissiveIntensity;
    }
  }

  dispose(): void {
    this.mesh.geometry.dispose();
    (this.mesh.material as THREE.Material).dispose();
  }
}
